module.exports = __webpack_public_path__ + "static/logo-907dcfe90da23c852c24ef849642f9ab.png";